import { getStoredAdminToken } from 'containers/Admin/adminSession';
import api, {
  ADMIN_API_BASE_URL,
  ADMIN_AUTH_TOKEN_HEADER,
} from './index';

type AdminLoginRequest = {
  username: string;
  password: string;
};

export type AdminAuthResponse = {
  authenticated: boolean;
  token?: string;
  expiresAt?: number | null;
  user?: {
    email?: string;
    name?: string;
    id?: string;
  };
};

type AdminEndpointPath = `/${string}`;

export const buildAdminApiUrl = (path: AdminEndpointPath) =>
  `${ADMIN_API_BASE_URL}${path}`;

export const getAdminApiHeaders = (headers: Record<string, string> = {}) => {
  const adminToken = getStoredAdminToken();

  return {
    ...headers,
    ...(adminToken ? { [ADMIN_AUTH_TOKEN_HEADER]: adminToken } : {}),
  };
};

export const buildAdminApiRequest = ({
  path,
  headers,
  ...request
}: {
  path: AdminEndpointPath;
  method?: string;
  body?: unknown;
  headers?: Record<string, string>;
  params?: Record<string, unknown>;
}) => ({
  ...request,
  headers: getAdminApiHeaders(headers),
  url: buildAdminApiUrl(path),
});

const adminApi = api.injectEndpoints({
  endpoints: build => ({
    adminLogin: build.mutation<AdminAuthResponse, AdminLoginRequest>({
      query: body => ({
        method: 'POST',
        url: buildAdminApiUrl('/auth/login'),
        body,
      }),
    }),
    adminLogout: build.mutation<{ authenticated: false }, void>({
      query: () => buildAdminApiRequest({
        method: 'POST',
        path: '/auth/logout',
      }),
    }),
    adminSession: build.query<AdminAuthResponse, void>({
      query: () => buildAdminApiRequest({
        method: 'GET',
        path: '/auth/session',
      }),
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useAdminLoginMutation,
  useAdminLogoutMutation,
  useAdminSessionQuery,
} = adminApi;
